import React from 'react';
import { Row, Col, Form, Button, Card, Alert, Spinner } from 'react-bootstrap';

/**
 * Araç fotoğrafı yükleme bileşeni
 * 
 * @param {Array} props.imagePreviews - Önizleme görüntüleri dizisi
 * @param {Function} props.handleImageChange - Resim değiştirme olayını işler
 * @param {Function} props.handleRemoveImage - Resim kaldırma olayını işler
 * @param {Function} props.handleClearAllImages - Tüm resimleri temizleme işlevi (opsiyonel)
 * @param {boolean} props.imageLoading - Resim yükleniyor mu?
 * @param {string} props.imageError - Resim yükleme hatası
 * @param {number} props.uploadProgress - Yükleme ilerleme durumu
 * @param {Function} props.uploadImages - Resimleri yükleme fonksiyonu (opsiyonel - düzenleme modunda kullanılır)
 * @param {boolean} props.isEditMode - Düzenleme modu (opsiyonel - butonu göstermek için kullanılır)
 * @param {Array} props.imageFiles - Seçilen resim dosyaları (opsiyonel)
 */
const VehiclePhotoUpload = ({
    imagePreviews = [],
    handleImageChange,
    handleRemoveImage,
    handleClearAllImages,
    imageLoading = false,
    imageError = '',
    uploadProgress = 0,
    uploadImages,
    isEditMode = false,
    imageFiles = []
}) => {
    return (
        <Card className="mb-4">
            <Card.Header>Araç Fotoğrafları</Card.Header>
            <Card.Body>
                {/* Seçilen/mevcut fotoğraflar önizlemesi */}
                {imagePreviews.length > 0 ? (
                    <div className="mb-3">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <h6 className="mb-0">{isEditMode ? 'Mevcut Fotoğraflar' : 'Seçilen Fotoğraflar'}</h6>
                            {handleClearAllImages && (
                                <Button
                                    variant="outline-danger"
                                    size="sm"
                                    onClick={handleClearAllImages}
                                >
                                    Tümünü Temizle
                                </Button>
                            )}
                        </div>
                        <Row>
                            {imagePreviews.map((preview, index) => (
                                <Col xs={6} key={`preview-${index}`} className="mb-3">
                                    <div className="position-relative">
                                        <img
                                            src={preview}
                                            alt={`Araç Fotoğrafı ${index + 1}`}
                                            className="img-thumbnail"
                                            style={{ width: '100%', height: '120px', objectFit: 'cover' }}
                                        />
                                        <Button
                                            variant="danger"
                                            size="sm"
                                            className="position-absolute top-0 end-0"
                                            onClick={() => handleRemoveImage(index)}
                                            title="Fotoğrafı Kaldır"
                                        >
                                            <i className="bi bi-x"></i>
                                        </Button>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </div>
                ) : (
                    <div className="text-center mb-3">
                        <div className="bg-light p-5 d-flex justify-content-center align-items-center" style={{ height: '150px' }}>
                            <p className="text-muted mb-0">Henüz fotoğraf {isEditMode ? 'yüklenmemiş' : 'seçilmedi'}</p>
                        </div>
                    </div>
                )}

                {/* Yeni fotoğraf yükleme alanı */}
                <Form.Group className="mb-3">
                    <Form.Label>Fotoğraf Ekle</Form.Label>
                    <div className="d-flex gap-2">
                        <Form.Control
                            type="file"
                            onChange={handleImageChange}
                            accept=".jpg,.jpeg,.png"
                            multiple
                        />
                        {isEditMode && imageFiles && imageFiles.length > 0 && (
                            <Button
                                variant="success"
                                size="sm"
                                onClick={uploadImages}
                                disabled={imageLoading}
                            >
                                Yükle
                            </Button>
                        )}
                    </div>
                    <Form.Text className="text-muted">
                        JPG, JPEG veya PNG formatında, maksimum 5MB boyutunda dosyalar yükleyebilirsiniz.
                        Birden fazla fotoğraf seçebilirsiniz.
                    </Form.Text>
                </Form.Group>

                {/* Yükleme durumu göstergesi */}
                {imageLoading && (
                    <div className="mb-3">
                        <div className="progress">
                            <div
                                className="progress-bar progress-bar-striped progress-bar-animated"
                                role="progressbar"
                                style={{ width: `${uploadProgress}%` }}
                                aria-valuenow={uploadProgress}
                                aria-valuemin="0"
                                aria-valuemax="100"
                            >
                                {uploadProgress}%
                            </div>
                        </div>
                        <p className="text-center mt-1 small">Fotoğraflar yükleniyor...</p>
                    </div>
                )}

                {imageError && <Alert variant="danger">{imageError}</Alert>}
            </Card.Body>
        </Card>
    );
};

export default VehiclePhotoUpload;